import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { untilText } from './upNextCopy';
import { useNow } from './useNow';

/** Only this text reads the clock every second, not the whole tab. */
const SECOND_MS = 1000;

/** "in 19 h", "in 58:12" under a scheduled chip (design s3, s4). Nothing after the time. */
const UntilTextComponent: React.FC<{ iso: string }> = ({ iso }) => {
  const intl = useIntl();
  const now = useNow(SECOND_MS);
  const text = untilText(intl, iso, now);
  return text === null ? null : <small>{text}</small>;
};

export const UntilText = TypedMemo(UntilTextComponent);
